import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 15.5 15.433"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.905 13.957H2.952v1.476H1.476v-1.476H.738A.74.74 0 0 1 0 13.22V2.148a.74.74 0 0 1 .738-.738h5.167V.369a.37.37 0 0 1 .43-.364l7.81 1.302a.74.74 0 0 1 .617.728v1.589h.738V5.1h-.738v5.167h.738v1.476h-.738v1.589a.74.74 0 0 1-.617.728l-.86.143v1.23H11.81v-.984l-5.475.913a.368.368 0 0 1-.43-.364zm1.476-.266 5.905-.984V2.66L7.38 1.676zm3.321-4.162c-.61 0-1.107-.827-1.107-1.846 0-1.018.496-1.845 1.107-1.845s1.108.827 1.108 1.845-.497 1.846-1.108 1.846"
    }, null, -1)
  ])))
}
export default { render: render }